import $ from 'jquery';
import select2 from 'select2'
import 'select2/dist/css/select2.css';  // optional if you have css loader

export default new class {

  init (Marionette) {
    // Create a new object for custom validation of a custom field.
    var CustomController = Marionette.Object.extend({

      initialize: function () {
        // Listen to the render:view event for a field type. Example: Textbox field.
        this.listenTo(window.nfRadio.channel('listselect'), 'render:view', this.renderView);
      },

      renderView: function (view) {
        let $select = $(view.$el).find('select')
        let isContact = window.location.href.includes('contact');
        let selectLabel = (isContact !== false) ? 'Enquiry Type' : 'Leasing Enquiry Type';
        $(view.$el)
          .prepend(`<div class="bg-white flex-shrink-0 uppercase border-none font-medium tracking-form text-13px px-4 py-4" style="margin-right: 10px;">${selectLabel}</div>`)
        $(view.$el)
          .find('.nf-field-label')
          .remove()
        $(view.$el)
          .find('.nf-field-element')
          .find('div')
          .last()
          .hide()
        select2($)
        $select.select2({
          // closeOnSelect: false,
        })
      },
    });
    new CustomController
  }

}

